// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"734":"67e13a98","849":"e52a6cf5"}[chunkId] + ".chunk.css";
};